import { RootStore } from './rootStore';
import { observable, action, computed, makeObservable } from 'mobx';
import LocalStorage from './localStorage';
import { IType } from '../data/types';

export enum SearchBy {
    Text,
    Account
}

export interface SearchItem extends IType {
    searchBy?: SearchBy;
}

export default class SearchStore {
    rootStore: RootStore;
    storage = new RecentSearch();

    constructor(rootStore: RootStore) {
        this.rootStore = rootStore;
        this._recentSearch = this.storage.value || [];
        makeObservable(this, {  
            _recentSearch: observable,
            searchQuery: observable,
            recentSearch: computed,
            getSearch: computed,
            findSearchByQuery: action,
            clearRecentList: action,
            updateRecentSearchList: action
        });
    }

    _recentSearch: SearchItem[];
    searchQuery = '';

    get recentSearch() : SearchItem[] {
        return this._recentSearch;
    }

    get getSearch(): SearchItem {
        return this._recentSearch.length ? this._recentSearch[0] : { searchBy: SearchBy.Text, value:'', label:'' };
    }

    findSearchByQuery = ( queryParams:any ): SearchItem|null => {
        const items = this._recentSearch;
        const accountId = queryParams.accountid;
        const value = items ? (queryParams.search || accountId) : null;
        if (value) {
            const idx = items.findIndex( item => item.value===value );
            if( idx>=0 )
                return items[idx];
        }
        return null;
    }

    clearRecentList = () => {
        this._recentSearch = [];
        this.storage.value = null;
    }

    updateRecentSearchList = (s: SearchItem|null ) => {
        if (s && s.value) {
            s.value = (s.value as string).trim();
            if (s.label)
                s.label = (s.label as string).trim();

            if (s.searchBy === SearchBy.Account)
                this.searchQuery = `accountId=${s.value}`;
            else
                this.searchQuery = `search=${s.value}`;
            
            const newList = this.add(this._recentSearch, { ...s });
            if (newList ) {
                this.storage.value = newList;
                this._recentSearch = newList;
            }
        }
        else
            this.searchQuery = ''; 
    }

    private add = (arr: SearchItem[], s: SearchItem): SearchItem[] | null => {
        if (!s || !s.value)
            return null;
        const MaxRecentItems = 10;
        const out = [...arr];
        const idx = out.findIndex(item => SearchStore.equals(s,item) );
        if (idx === 0)    // is first in list
            return null;
        if (idx >= 0)
            out.splice(idx, 1);
        out.splice(0, 0, s);
        if (out.length > MaxRecentItems)
            out.splice(MaxRecentItems, out.length - MaxRecentItems);
       return out;
    }

    private static equals = (a: SearchItem, b: SearchItem) => {
        if( a.searchBy != b.searchBy )
            return false;
        const str1 = a.value as string;
        const str2 = b.value as string;
        return str1.localeCompare(str2, undefined, { sensitivity: 'accent' }) === 0;
    }
}

class RecentSearch extends LocalStorage<SearchItem[]> {
    constructor() {
        super('recentSearch');
    }
}
